import { useSearchParams } from "react-router-dom";
import { usePatients } from "../../hooks/useData";

export const usePickedPatient = () => {
  const [params, setParams] = useSearchParams();
  const { data: patients } = usePatients();
  const pid = params.get("patient") || (patients?.find((p) => p.is_demo) || patients?.[0])?.id;
  return { pid, patients, setPid: (id) => setParams({ patient: id }) };
};

export const PatientPicker = ({ pid, patients, setPid }) => (
  <select data-testid="patient-picker" value={pid || ""} onChange={(e) => setPid(e.target.value)}
    className="h-11 rounded-xl border border-border bg-card px-3 text-sm font-semibold">
    {patients?.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
  </select>
);
